import React from "react";
import { Outlet } from "react-router-dom";
import AppView from "layouts/AppView";
import { Box, Typography } from "@mui/material";


import "./style.css";

export default class Auth extends AppView {
    // A late 401 from a request started on an app page lands here after the redirect to /auth/login.
    // The visitor is already signed out, and the default AppView.logout() would leave the loading spinner on forever.
    logout() {}

    renderView() {
        return (
            <Box className="authPage flex1 flex justify-center align-center">
                <Box className="leftSide flex column gap24">
                    <Outlet />
                </Box>
                <Box className="rightSideAuth">
                    <Box className="bg">
                        <Box className="content">
                            <Typography component="span" className="titleBg">Sign In</Typography>
                            <Typography component="span" className="titleSecBg">Connexxtion app</Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
        );
    }
}
